import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import { PageState } from '../../../core/page/page.types';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { VendorDataItem } from './vendor_list_types';
import { VENDOR_LIST_STORAGE_KEY } from '../vendor_const';
import { pageStateVM } from '../../../core/page/page_view_models';

export const pageStateAtom = atom<PageState>(pageStateVM());
export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const vendorDataAtom = atom<TableDataState<VendorDataItem>>(tableDataVM<VendorDataItem>());

export function setAtomVendorListTableViewState(): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);
    tableViewRepo.setTable(VENDOR_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}
